<xemex-dialog-shell [title]="'myProfile.tabs.security.content.titleChangePassword' | translate">
  <form class="change-password-dialog__form" [formGroup]="securityForm">
    <xemex-text-field
      formControlName="oldPassword"
      [type]="'password'"
      [label]="'myProfile.tabs.security.content.oldPassword' | translate"
      [placeholder]="'general.placeholderInput' | translate"
      [required]="true"
      [invalid]="hasError('oldPassword', 'required')"
      [errorText]="
        'error.required'
          | translate: { field: ('myProfile.tabs.security.content.oldPassword' | translate) }
      "
    />

    <xemex-text-field
      formControlName="newPassword"
      [type]="'password'"
      [label]="'myProfile.tabs.security.content.newPassword' | translate"
      [placeholder]="'general.placeholderInput' | translate"
      [required]="true"
      [invalid]="hasError('newPassword', 'required') || hasError('newPassword', 'passwordInvalid')"
      [errorText]="
        hasError('newPassword', 'required')
          ? ('error.required'
            | translate: { field: ('myProfile.tabs.security.content.newPassword' | translate) })
          : ('error.passwordNotStrong' | translate)
      "
    />

    <xemex-text-field
      formControlName="confirmNewPassword"
      [type]="'password'"
      [label]="'myProfile.tabs.security.content.confirmNewPassword' | translate"
      [placeholder]="'general.placeholderInput' | translate"
      [required]="true"
      [invalid]="
        hasError('confirmNewPassword', 'required') ||
        hasError('confirmNewPassword', 'notMatched') ||
        hasError('confirmNewPassword', 'passwordInvalid')
      "
      [errorText]="
        hasError('confirmNewPassword', 'required')
          ? ('error.required'
            | translate
              : { field: ('myProfile.tabs.security.content.confirmNewPassword' | translate) })
          : hasError('confirmNewPassword', 'notMatched')
            ? ('error.confirmPasswordInvalid' | translate)
            : ('error.passwordNotStrong' | translate)
      "
    />
  </form>

  <div actions class="change-password-dialog__actions">
    <xemex-text-button type="button" intent="primary" (click)="onCancel()">
      {{ 'general.btnCancel' | translate }}
    </xemex-text-button>
    <xemex-filled-button type="button" (click)="onUpdatePassword()">
      {{ 'myProfile.tabs.security.content.btnUpdatePassword' | translate }}
    </xemex-filled-button>
  </div>
</xemex-dialog-shell>
